import { Component, ElementRef, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_shared/_services/authentication.service';
import { StatutEnum } from '../_shared/_enums/statut.enum';

import { first } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { PoloHelper } from '@app/_shared/_helpers/polo.helper';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';
import { RedirectService } from '@app/_shared/_services/redirect.service';
import { LoadingService } from '@app/_shared/_services/loading.service';
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.scss'],
  // providers: [JwtHelper]
})
export class AuthentificationComponent implements OnInit {

  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  error = '';
  environment = environment;

  withPassword = true;
  withLogin = true

  path ="";
  constructor(
      private formBuilder: UntypedFormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private poloHelper:PoloHelper,
      private authenticationService: AuthenticationService,
      private globalHelper: GlobalHelper,
      private el : ElementRef,
      private redirectService:RedirectService,
      private loadingService:LoadingService
  ) {
      // redirect to home if already logged in
      // if (this.authenticationService.currentUserValue) {
      //   // alert('moli');
      //     this.router.navigate(['/']);
      // }
    this.loadingService.show()
  }

  ngAfterViewInit() {
    // this.body.classList.add('polo');
    // this.body.classList.remove('dashcode');
    this.globalHelper.loadExternalStyles(this.el,'theme/DASHCODE/css/sidebar-menu.css','DASHCODE');
    this.globalHelper.loadExternalStyles(this.el,'theme/DASHCODE/css/app.css','DASHCODE');
    setTimeout(() => this.loadingService.hide(), 2000)
  }
  toggleWithPassword(){
    this.withPassword = !this.withPassword;
  }
  ngOnInit() {
    // this.poloHelper.documentReadyFunctions();
    console.log(this.route.snapshot.routeConfig.path)
    this.path = this.route.snapshot.routeConfig.path;
    this.globalHelper.updateMetaTags(
      {title:this.path =='auth/login' ?'Me connecter' : 'M\'inscrire',
      description:'OUI à un logement autonome, avec D\'Clic Jeune',
    url:window?.location.href})


    if(this.path == "auth/logout") {
      this.authenticationService.logout()
      const returnUrl =  '/';
      // if(!environment.adminOnly)
      this.redirectService.redirectToIndexWithPostParams(environment.cllajUrl + '/login.php?logout', {redirect: location.protocol +'//' +location.host  + environment.baseHref + returnUrl})
      // else
      // this.router.navigate(['/']);
      return false
    }

    else  if (this.authenticationService.user) {
        this.router.navigate(['/']);
    }
  }
  goBack() {
    if(window){
    window.history.back();
    }
  }


  // loginForm: FormGroup;
  // public error: boolean = false;
  // public errorPassword: boolean = false;
  // public errorPasswordNumber: boolean = false;
  // public params: any;
  // public modal_no_status:boolean = false;
  // public first_login:boolean = false;
  // public requestNewPassword:any = '';
  // public requestConfirmNewPassword:any = '';
  // public verifyPwd:boolean = false;
  // public showNoVendeur:boolean = false;

  // constructor(public activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private authenticationService: AuthenticationService, private router: Router) {
  //     this.loginForm = formBuilder.group({
  //       'username': ['', Validators.required],
  //       'password': ['', Validators.required]
  //     });
  //     const state: RouterStateSnapshot = router.routerState.snapshot;
  //   }


    // onSubmit() {
    //   let jwtHelper: JwtHelper = new JwtHelper();
    //   console.log('[PARAMETRE : ]', this.router.routerState.snapshot.root.queryParams);
    //   this.authenticationService.authenticate(this.loginForm.value).subscribe(res => {
    //     console.log("RES : ", res);
    //     if(res == false){
    //       this.error = true;
    //     }
    //     else if(res != false){
    //       this.authenticationService.token = res.token;
    //       sessionStorage.setItem('token', res.token);
    //       // console.log("ID_User: ", this.loginForm.value.username);
    //       this.dataGlobal.user = jwtHelper.decodeToken(sessionStorage.getItem('token'));
    //       console.log("[USER]: ", this.dataGlobal.user);
    //       if(this.dataGlobal.user['Last_Login']){
    //         this.routerStatut();
    //       }
    //       else{
    //         this.first_login = true;
    //       }

    //     }

    //   });
    // }

    // ngOnInit() {
    //   this.dataGlobal.user = null;
    // }



    // OnSubmitNewPassword(){
    //   this.errorPassword = false;
    //   let jwtHelper: JwtHelper = new JwtHelper();

    //   if(this.requestNewPassword != this.requestConfirmNewPassword){this.errorPassword = true;}
    //   else{
    //     this.dataGlobal.new_pwd_user(this.dataGlobal.user['ID_User'], this.requestNewPassword).subscribe(res =>{
    //       console.log(res);
    //       if(res != false){
    //         this.first_login = false;
    //         this.errorPassword = false;
    //         var d = new Date();
    //         this.dataGlobal.user['Last_Login'] = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate();
    //         // this.routerStatut();
    //       }
    //     })
    //   }

    // }

    // closeModal(){
    //   this.modal_no_status = false;
    //   this.authenticationService.logout();
    //   this.router.navigate(['login']);
    // }


    // verifyPassword(str){
    //   this.verifyPwd = false;
    //   if (str.search(/\d/) != -1) {
    //     console.log('Good Pwd');
    //     this.verifyPwd = true;
    //   }
    //   else{
    //     console.log('Bad Pwd');
    //     this.verifyPwd = false;
    //     this.errorPasswordNumber = true;
    //   }
    // }

    //   // routerStatut(){
    //   //   console.log('routerStatut',this.dataGlobal.user['Statut']);
    //   //   if(this.dataGlobal.user['Statut'] == StatutEnum.Vendeur){this.router.navigate(['/Vendeur']);}
    //   //   else if(this.dataGlobal.user['Statut'] == StatutEnum['Chef des ventes'] || this.dataGlobal.user['Statut'] == StatutEnum['Directeur Commercial']){this.router.navigate(['/ChefVente']);}
    //   //   else if(this.dataGlobal.user['Statut'] == StatutEnum.Facturation){this.router.navigate(['/Facturation']);}
    //   //   else if(this.dataGlobal.user['Statut'] == StatutEnum.Archives || this.dataGlobal.user['Statut'] == StatutEnum.Annexes || this.dataGlobal.user['Statut'] == StatutEnum['Comptabilité']){this.router.navigate(['/Archives']);}
    //   //   else if(this.dataGlobal.user['Statut'] == StatutEnum["Planning de livraison"]){this.router.navigate(['/Planning']);}
    //   //   else if(this.dataGlobal.user['Statut'] == StatutEnum.Accessoire){this.router.navigate(['/Accessoire']);}
    //   //   else if(this.dataGlobal.user['Statut'] == StatutEnum['Prépa.'] || this.dataGlobal.user['Statut'] == StatutEnum.Douane){this.router.navigate(['/Preparation']);}
    //   //   else if(this.dataGlobal.user['Statut'] == StatutEnum.Admin){this.router.navigate(['/AdminFolder']);}
    //   // }

}
